<script setup>
// MEDIDOR DE TELA (PWA, 25/09/2026). Abrir o advup com `?medir-tela` mostra as
// medidas reais do aparelho — a folga embaixo no iPhone do Victor não aparece
// no simulador, e a regra da casa é medir no aparelho antes de mexer. Toque
// para fechar; fica ligado só nesta aba (sessionStorage).
import { onBeforeUnmount, onMounted, ref } from 'vue';

const linhas = ref([]);
const aberto = ref(true);

function medir() {
  const sonda = document.createElement('div');
  sonda.style.cssText =
    'position:fixed;top:0;left:0;width:0;visibility:hidden;height:100dvh;' +
    'padding-top:env(safe-area-inset-top);padding-bottom:env(safe-area-inset-bottom)';
  document.body.appendChild(sonda);
  const estilo = getComputedStyle(sonda);
  const alturaDvh = sonda.getBoundingClientRect().height;
  sonda.remove();
  const app = document.getElementById('app')?.getBoundingClientRect();
  const main = document.querySelector('main');
  const nav = document
    .querySelector('.advup-mobile-bottom-nav')
    ?.getBoundingClientRect();
  const standalone =
    window.matchMedia('(display-mode: standalone)').matches ||
    window.navigator.standalone === true;
  linhas.value = [
    ['modo', standalone ? 'PWA (tela cheia)' : 'navegador'],
    ['tela (screen)', `${window.screen.width}×${window.screen.height}`],
    ['innerHeight', window.innerHeight],
    ['visualViewport', Math.round(window.visualViewport?.height || 0)],
    ['100dvh (+ áreas)', Math.round(alturaDvh)],
    ['área segura topo', estilo.paddingTop],
    ['área segura baixo', estilo.paddingBottom],
    ['#app', app ? `${Math.round(app.top)}→${Math.round(app.bottom)}` : '—'],
    ['main margem baixo', main ? getComputedStyle(main).marginBottom : '—'],
    [
      'barra de baixo',
      nav ? `${Math.round(nav.top)}→${Math.round(nav.bottom)}` : 'escondida',
    ],
    ['rota', window.location.pathname.split('/').slice(-2).join('/')],
    [
      'aparelho',
      (navigator.userAgent.match(/(iPhone|iPad|Android)[^;)]*/) || ['?'])[0],
    ],
  ];
}

let relogio = null;
onMounted(() => {
  medir();
  relogio = setInterval(medir, 1500);
});
onBeforeUnmount(() => clearInterval(relogio));
</script>

<template>
  <button v-if="aberto" type="button" class="medidor" @click="aberto = false">
    <span v-for="[nome, valor] in linhas" :key="nome" class="medidor__linha">
      <span>{{ nome }}</span>
      <strong>{{ valor }}</strong>
    </span>
  </button>
</template>

<style scoped>
.medidor {
  position: fixed;
  top: calc(env(safe-area-inset-top) + 90px);
  left: 50%;
  z-index: 9999;
  display: flex;
  flex-direction: column;
  gap: 2px;
  width: min(92vw, 360px);
  padding: 10px 12px;
  border-radius: 12px;
  font:
    12px/1.35 ui-monospace,
    monospace;
  text-align: left;
  background: rgb(15 23 42 / 92%);
  color: #fff;
  transform: translateX(-50%);
  box-shadow: 0 10px 30px rgb(0 0 0 / 35%);
}
.medidor__linha {
  display: flex;
  justify-content: space-between;
  gap: 12px;
}
.medidor__linha strong {
  color: #5eead4;
}
</style>
